import { createSelector } from '@ngrx/store';
import { Gallery } from '../../models/gallery.model';
import { AppState } from '../reducers';

export const selectState = (state: AppState) => state;
export const selectGalleries = (state: AppState) => state.galleries.items;
export const selectGalleryMedia = (state: AppState) => state.galleries.mediaMapping;
export const selectUserGalleries = createSelector(selectState, (state: AppState) => {
  return state.galleries.items.filter(x => x.createdByUserId === state.user.user.userLoginId);
});
export const selectGalleryById = (props: any) =>
  createSelector(selectGalleries, (galleries: Gallery[]) => {
    let galleyId = +props.galleryId;
    let gallery = galleries.filter(a => a.id === galleyId)[0];
    return gallery;
  });
export const selectMediaForGallery = (props: any) =>
  createSelector(selectState, (state: AppState) => {
    const mapping = state.galleries.mediaMapping.filter(x => x.galleryId == props.galleryId);
    let media = [];
    if (mapping && mapping.length > 0) {
      media = state.media.items.filter(mItem => mapping[0].mediaIds.indexOf(+mItem.mediaId) > -1);
      media.sort((a, b) => {
        if (a.sort > b.sort) return 1;
        if (b.sort > a.sort) return -1;
        if (a.sort == b.sort) {
          if (a.mediaId > b.mediaId) return 1;
          if (b.mediaId > a.mediaId) return -1;
        } else return 0;
      });
      return media;
    }
    return [];
  });
export const selectAllGalleriesForUserOffices = createSelector(selectState, (state: AppState) => {
  let userOfficeIds = state.offices.offices.map(o => o.officeId);
  let filterdGalleries = [];
  filterdGalleries = state.galleries.items.filter(g => userOfficeIds.indexOf(g.officeId) > -1);
  return filterdGalleries;
});
export const selectTopViewedGalleries = createSelector(selectState, (state: AppState) => {
  let topViewedIds = null;
  if (state.galleries.topViewed) {
    topViewedIds = state.galleries.topViewed.slice();
  }

  let topViewedGalleries = null;
  if (topViewedIds) {
    topViewedGalleries = topViewedIds.map(id => {
      let match = state.galleries.items.filter(g => g.id === id);
      if (match && match.length > 0) {
        return match[0];
      }
    });
  }

  return topViewedGalleries;
});
